import React, { useState, useEffect } from 'react'
import './ForumDiscussionItemTemplate.css'
import { useNavigate, useParams } from 'react-router-dom'
import { addCommentForum, getForum } from '../../http/http'
import Loader from '../../components/Loader/Loader'
import { BsFillCursorFill } from "react-icons/bs"
import { convertDate, sanitizeInput } from '../../helpers/utils'


const ForumDiscussionItemTemplate = () => {
    const navigate = useNavigate()
    let { id } = useParams();

    const [data, setData] = useState();
    const [comment, setComment] = useState("")
    const [isLoading, setIsLoading] = useState(true)


    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, [id])

    const loadData = async () => {
        const resp = await getForum(id)
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            setData(resp.data.data)
            setIsLoading(false)

        }
    }

    const sendComment = async () => {
        const token = localStorage.getItem("user_token");
        const sanitizedComment = sanitizeInput(comment);
        const response = await addCommentForum(id, token, sanitizedComment)
        if (response.response && response.response.status !== 200) {
            console.log("data error ", response.response)
        } else {
            setComment("");
            loadData();
            setIsLoading(false);

        }
    }

    return (
        <div>
            {!isLoading ?
                <>
                    <div className="forum__item-template__header">{data?.topic}</div>
                    <div className="forum__item__description ql-editor text-center" dangerouslySetInnerHTML={{ __html: (data && data?.body) }}></div>
                    <div className="forum__item-template__content ql-editor" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
                        <div className="text-content">

                            {data?.comments?.map(item => <div className='forum-message-row mb-3 mt-3'>
                                <div className='forum-user-container d-flex w-100 justify-content-between'>
                                    <div className="forum-message-row-user">{item.creator?.name}</div>
                                    <div className="forum-message-row-date"> {convertDate(item.created_at?.substring(0, 10))}</div>
                                </div>

                                <div className='text-left'>

                                    <div className="forum-message-row-message ql-editor" dangerouslySetInnerHTML={{ __html: (item?.body) }}></div>
                                </div>
                                <br />
                            </div>)}

                            {!(localStorage.getItem("user_token")) ? <><div className='forum-must-signin'>Vous devez être connecté(e) pour ajouter un commentaire</div>
                                <div className="d-flex  w-100"><button onClick={() => {

                                    localStorage.setItem("redirect_url", window.location.pathname);
                                    navigate(`/auth`)
                                }} className="forum__item__read-button mx-auto">Se Connecter</button></div>

                            </> :
                                <div className='forum-input-container'>
                                    <input value={comment} onChange={(e) => setComment(e.target.value)} className='forum-input' type="text" placeholder='Ajoutez votre commentaire ici...' />
                                    <BsFillCursorFill onClick={sendComment} className='forum-button' src={BsFillCursorFill} alt='send_msg' />
                                </div>}

                            <div className="buttons-content d-flex justify-content-center">
                                <button onClick={() => navigate(`/forums-discussions`)} className="forum__item__back-button">Retour</button>
                            </div>
                        </div>
                    </div>
                </>
                :
                <Loader />}
        </div>)
}

export default ForumDiscussionItemTemplate

